export const MAX_ZOOM_LEVEL = 17;
export const MIN_ZOOM_LEVEL = 1;
export const DEFAULT_ZOOM_LEVEL = 10;
export const ZOOM_INCREMENT = 0.25;
export const OFFSET_SHIFT_IN_PX = 50;
export const DEFAULT_BOUNDS_PADDING_IN_PX = 75;

export const AVERAGE_CARD_HEIGHT = 230;
export const FLOATING_CARD_BOTTOM = 8;
